export default function EmptyItem() {
  return (
    <div className="ReportConfigEditorSidebar--listItem empty p-3">
      <div className="text-sm">The queue is empty</div>
    </div>
  );
}
